import { render, staticRenderFns } from "./PaymentNotificationRecipients.vue?vue&type=template&id=2c5a5844&scoped=true&"
import script from "./PaymentNotificationRecipients.vue?vue&type=script&lang=js&"
export * from "./PaymentNotificationRecipients.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNotificationRecipients.vue?vue&type=style&index=0&id=2c5a5844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a5844",
  null
  
)

export default component.exports